import {Route, Routes} from 'react-router-dom';
import {RequirePermission} from '../../utils/RequirePermission';
import {rbacActions} from '../../config/rbac/actions';

import {IndexPage} from './pages/IndexPage';
import {EditPage} from './pages/EditPage';
import {NoAccessPage} from '../home/pages/NoAccessPage';

// The module's own routes, mounted by the app at `users/*`. Each page is gated
// on the same action its menu entry and buttons check. A person without it
// sees NoAccessPage in place: redirecting them to "/" looped with the home
// page, which sends signed-in people here (FNP-2015). Adding a person happens
// in the New User drawer, so there is no `add` page: the console's copy routed
// one that nothing linked to.
export const UsersLayout = () => {
    return (
        <Routes>
            <Route
                path='/'
                element={
                    <RequirePermission action={rbacActions.ListUsers} denied={<NoAccessPage/>}>
                        <IndexPage/>
                    </RequirePermission>
                }
            />
            <Route
                path=':id'
                element={
                    <RequirePermission action={rbacActions.GetUser} denied={<NoAccessPage/>}>
                        <EditPage/>
                    </RequirePermission>
                }
            />
        </Routes>
    );
};
